import { render, staticRenderFns } from "./CategoryDemandDetails.vue?vue&type=template&id=55f74ec4&scoped=true"
import script from "./CategoryDemandDetails.vue?vue&type=script&lang=js"
export * from "./CategoryDemandDetails.vue?vue&type=script&lang=js"
import style0 from "./CategoryDemandDetails.vue?vue&type=style&index=0&id=55f74ec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f74ec4",
  null
  
)

export default component.exports